import { render } from "./TableLightbox.vue?vue&type=template&id=747b4004&scoped=true"
import script from "./TableLightbox.vue?vue&type=script&lang=js"
export * from "./TableLightbox.vue?vue&type=script&lang=js"

import "./TableLightbox.vue?vue&type=style&index=0&id=747b4004&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747b4004"]])

export default __exports__